import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('v-select', vSelect)
